var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApiReference = function SvgApiReference(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.303 6.785a.75.75 0 1 1 1.393.552l-3.938 9.94a.75.75 0 0 1-1.395-.554zm-7.591.442a.75.75 0 1 1 1.06 1.06L3.061 12l3.711 3.713a.75.75 0 0 1-1.06 1.06l-3.889-3.89a1.25 1.25 0 0 1 0-1.767zm11.515 0a.75.75 0 0 1 1.06 0l3.89 3.889a1.25 1.25 0 0 1 0 1.768l-3.89 3.89a.75.75 0 0 1-1.06-1.061L20.939 12l-3.712-3.712a.75.75 0 0 1 0-1.06"
  })));
};
export default SvgApiReference;